import { render, staticRenderFns } from "./OptionTiles.vue?vue&type=template&id=16803b9e&scoped=true"
import script from "./OptionTiles.vue?vue&type=script&lang=js"
export * from "./OptionTiles.vue?vue&type=script&lang=js"
import style0 from "./OptionTiles.vue?vue&type=style&index=0&id=16803b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16803b9e",
  null
  
)

export default component.exports